<template>
	<div class="section">
		<div class="container">
			<h1>Instructions</h1>
			<br />
			<video src="https://ctc-document.s3.amazonaws.com/instructional.mp4" controls>
				Your browser does not support the video tag.
			</video>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>
